module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-1280x320-16fa1a02842644b4ab122a18165eb68b.webp";